import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { SEARCH_CONFIG } from "src/libs/portal/season/search-config";
import {
    MOCK_SEARCH_RESPONSE,
    MockChunkType,
    MockSearchItem
} from "src/libs/portal/season/search-mock";

type SearchMode = 'keyword' | 'dense' | 'hybrid';
type SelectFilterKey = 'language' | 'field';
type NoticeType = 'idle' | 'error' | 'ready';

interface SearchResultView extends MockSearchItem {
    rank: number;
    displayScore: number;
    matchCount: number;
}

interface SearchTimings {
    keyword_ms: number;
    bi_encoder_ms: number;
    cross_encoder_ms: number;
    total_ms: number;
}

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
:host {
  display: block;
  min-height: 100%;
}

:host,
:host * {
  box-sizing: border-box;
}

button,
input,
select {
  font: inherit;
}

button {
  color: inherit;
}

.search-page {
  --navy: #10213b;
  --navy-soft: #2c405f;
  --blue: #1769e0;
  --blue-dark: #0f56bf;
  --mint: #18bfa7;
  --text: #182b45;
  --muted: #697b93;
  --soft-muted: #8c9aad;
  --line: #dfe7f1;
  --surface: #ffffff;
  min-height: 100dvh;
  color: var(--text);
  background: radial-gradient(circle at 50% 8%, rgba(51, 130, 240, 0.11), transparent 31rem), linear-gradient(180deg, #f7faff 0, #f4f7fb 600px, #f3f6fa 100%);
  font-family: Pretendard, SUIT, "Noto Sans KR", "Apple SD Gothic Neo", Arial, sans-serif;
  letter-spacing: -0.018em;
}

.site-header {
  position: relative;
  z-index: 10;
  height: 68px;
  background: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(211, 222, 235, 0.9);
  backdrop-filter: blur(16px);
}

.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: min(1180px, 100% - 48px);
  height: 100%;
  margin: 0 auto;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 7px 5px 3px;
  cursor: pointer;
  background: transparent;
  border: 0;
  border-radius: 10px;
  transition: background 150ms ease;
}

.brand:hover {
  background: #f2f7fd;
}

.brand-mark {
  display: grid;
  width: 34px;
  height: 34px;
  color: var(--mint);
  place-items: center;
}

.brand-mark svg {
  width: 100%;
  height: 100%;
}

.brand-copy {
  display: flex;
  align-items: baseline;
  gap: 7px;
}

.brand-copy strong {
  color: var(--navy);
  font-size: 20px;
  font-weight: 780;
  letter-spacing: -0.045em;
}

.brand-kicker {
  align-self: flex-start;
  margin-top: 2px;
  color: #8090a4;
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.brand-badge {
  padding: 3px 6px;
  color: #087f72;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.04em;
  background: #e5f8f5;
  border: 1px solid #bdebe4;
  border-radius: 5px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 9px;
}

.database-button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 32px;
  padding: 0 11px;
  color: #49627f;
  font-size: 11px;
  font-weight: 690;
  cursor: pointer;
  background: #fff;
  border: 1px solid #d9e4f0;
  border-radius: 9px;
  transition: color 150ms ease, border-color 150ms ease, background 150ms ease;
}

.database-button:hover,
.database-button[aria-expanded=true] {
  color: var(--blue);
  background: #f3f8ff;
  border-color: #adcaf0;
}

.database-button svg {
  width: 16px;
  height: 16px;
}

.header-status {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 11px;
  color: #65768c;
  font-size: 11px;
  font-weight: 650;
  background: #f7f9fc;
  border: 1px solid var(--line);
  border-radius: 999px;
}

.status-dot {
  display: block;
  width: 7px;
  height: 7px;
  background: #34c99e;
  border-radius: 50%;
  box-shadow: 0 0 0 4px rgba(52, 201, 158, 0.1);
}

.drawer-backdrop {
  position: fixed;
  z-index: 40;
  inset: 0;
  padding: 0;
  cursor: default;
  background: rgba(13, 31, 55, 0.34);
  border: 0;
  backdrop-filter: blur(2px);
  animation: backdrop-in 180ms ease-out;
}

.database-drawer {
  position: fixed;
  z-index: 50;
  top: 0;
  right: 0;
  width: min(500px, 100% - 28px);
  height: 100dvh;
  overflow-y: auto;
  background: #f8fbff;
  border-left: 1px solid #d6e2f0;
  box-shadow: -22px 0 60px rgba(15, 40, 74, 0.2);
  animation: drawer-in 220ms ease-out;
}

@keyframes backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes drawer-in {
  from {
    transform: translateX(24px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.drawer-header {
  position: sticky;
  z-index: 2;
  top: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 25px 27px 21px;
  background: rgba(255, 255, 255, 0.94);
  border-bottom: 1px solid #dce6f1;
  backdrop-filter: blur(16px);
}

.drawer-eyebrow {
  display: block;
  margin-bottom: 5px;
  color: var(--blue);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.14em;
}

.drawer-header h2 {
  margin: 0;
  color: var(--navy);
  font-size: 22px;
  font-weight: 780;
}

.drawer-header p {
  margin: 5px 0 0;
  color: #7b8da3;
  font-size: 10px;
}

.drawer-close {
  display: grid;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  color: #647992;
  cursor: pointer;
  background: #f5f8fc;
  border: 1px solid #dbe5ef;
  border-radius: 10px;
  place-items: center;
}

.drawer-close:hover {
  color: var(--blue);
  background: #eef6ff;
}

.drawer-close svg {
  width: 17px;
  height: 17px;
}

.drawer-content {
  padding: 22px 27px 34px;
}

.drawer-intro {
  padding: 15px 16px;
  background: #eef6ff;
  border: 1px solid #cfe1f8;
  border-radius: 13px;
}

.intro-status {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #244d7b;
  font-size: 11px;
}

.drawer-intro p {
  margin: 8px 0 0;
  color: #5f7690;
  font-size: 10px;
  line-height: 1.65;
}

.system-strip {
  display: grid;
  grid-template-columns: 1.25fr 1fr 0.75fr;
  gap: 1px;
  margin-top: 10px;
  overflow: hidden;
  background: #dfe8f2;
  border: 1px solid #dfe8f2;
  border-radius: 11px;
}

.system-strip > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
  padding: 10px;
  background: #fff;
}

.system-strip span {
  color: #8a98aa;
  font-size: 7px;
  font-weight: 680;
}

.system-strip strong {
  overflow: hidden;
  color: #405b78;
  font-size: 9px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.database-section {
  margin-top: 28px;
}

.section-heading {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 13px;
}

.section-heading > span {
  display: grid;
  flex: 0 0 auto;
  width: 25px;
  height: 25px;
  color: var(--blue);
  font-size: 8px;
  font-weight: 800;
  background: #eaf3ff;
  border-radius: 7px;
  place-items: center;
}

.section-heading h3 {
  margin: 0;
  color: #243b57;
  font-size: 14px;
  font-weight: 740;
}

.section-heading p {
  margin: 4px 0 0;
  color: #8796a8;
  font-size: 9px;
}

.data-summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
}

.data-summary-card {
  display: flex;
  min-width: 0;
  min-height: 94px;
  flex-direction: column;
  padding: 13px;
  background: #fff;
  border: 1px solid #dfe8f2;
  border-radius: 11px;
}

.data-summary-card > span {
  color: #75869b;
  font-size: 9px;
  font-weight: 650;
}

.data-summary-card strong {
  margin-top: 7px;
  color: #173b68;
  font-size: 18px;
  font-weight: 770;
  letter-spacing: -0.035em;
}

.data-summary-card small {
  margin-left: 3px;
  color: #74869c;
  font-size: 9px;
}

.data-summary-card em {
  margin-top: auto;
  padding-top: 7px;
  overflow: hidden;
  color: #8a98aa;
  font-size: 8px;
  font-style: normal;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.source-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.source-card {
  padding: 15px;
  background: #fff;
  border: 1px solid #dfe8f2;
  border-radius: 12px;
}

.source-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 11px;
  border-bottom: 1px solid #edf1f6;
}

.source-card-header strong {
  color: #24415f;
  font-size: 13px;
}

.source-card-header span {
  padding: 4px 7px;
  color: #167a6e;
  font-size: 8px;
  font-weight: 720;
  background: #e6f7f4;
  border-radius: 999px;
}

.source-card dl {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 11px 0 0;
}

.source-card dl > div {
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr);
  gap: 8px;
}

.source-card dt {
  color: #8a98aa;
  font-size: 8px;
  font-weight: 650;
}

.source-card dd {
  margin: 0;
  color: #4f657e;
  font-size: 9px;
  font-weight: 570;
  line-height: 1.45;
}

.schema-list {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.schema-list span {
  padding: 7px 9px;
  color: #516b87;
  font-size: 9px;
  font-weight: 600;
  background: #fff;
  border: 1px solid #dce6f1;
  border-radius: 8px;
}

.pipeline-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.pipeline-list li {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 38px;
}

.pipeline-list li:not(:last-child)::after {
  position: absolute;
  top: 27px;
  bottom: -7px;
  left: 11px;
  width: 1px;
  background: #cbdbee;
  content: "";
}

.pipeline-list span {
  display: grid;
  z-index: 1;
  width: 23px;
  height: 23px;
  color: #fff;
  font-size: 8px;
  font-weight: 750;
  background: #347fdc;
  border-radius: 50%;
  place-items: center;
}

.pipeline-list strong {
  color: #4d647d;
  font-size: 10px;
  font-weight: 630;
}

.retrieval-tests {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 9px;
}

.retrieval-test {
  display: flex;
  min-width: 0;
  flex-direction: column;
  padding: 12px;
  background: #173b68;
  border-radius: 11px;
}

.retrieval-test span {
  color: #a9c3e2;
  font-size: 8px;
  font-weight: 700;
}

.retrieval-test strong {
  margin-top: 4px;
  color: #fff;
  font-size: 11px;
}

.retrieval-test em {
  margin-top: 8px;
  color: #8fb1d8;
  font-size: 7px;
  font-style: normal;
}

.quality-goal-list {
  overflow: hidden;
  background: #fff;
  border: 1px solid #dfe8f2;
  border-radius: 12px;
}

.quality-goal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 11px 13px;
}

.quality-goal + .quality-goal {
  border-top: 1px solid #edf1f6;
}

.quality-goal > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.quality-goal strong {
  color: #3e5670;
  font-size: 9px;
}

.quality-goal span {
  color: #909daf;
  font-size: 8px;
}

.quality-goal em {
  flex: 0 0 auto;
  padding: 4px 7px;
  color: #1769d8;
  font-size: 8px;
  font-style: normal;
  font-weight: 760;
  background: #edf5ff;
  border-radius: 6px;
}

.main-content {
  width: min(1040px, 100% - 48px);
  margin: 0 auto;
}

.hero {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 92px 0 64px;
  text-align: center;
}

.hero-label {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 19px;
  padding: 7px 11px;
  color: var(--blue);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
  background: rgba(231, 242, 255, 0.84);
  border: 1px solid #cbdffa;
  border-radius: 999px;
}

.hero-label svg {
  width: 15px;
  height: 15px;
}

.hero h1 {
  margin: 0;
  color: var(--navy);
  font-size: clamp(36px, 4vw, 52px);
  font-weight: 790;
  line-height: 1.18;
  letter-spacing: -0.055em;
}

.hero > p {
  margin: 20px 0 0;
  color: var(--muted);
  font-size: 16px;
  line-height: 1.72;
}

.search-form {
  width: min(820px, 100%);
  margin-top: 38px;
}

.search-box {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  min-height: 70px;
  padding: 7px 8px 7px 22px;
  background: #fff;
  border: 1px solid #cbd9ea;
  border-radius: 18px;
  box-shadow: 0 18px 48px rgba(28, 71, 127, 0.12), 0 2px 6px rgba(23, 55, 93, 0.04);
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.search-box:focus-within {
  border-color: #6ca5f3;
  box-shadow: 0 0 0 4px rgba(45, 124, 242, 0.1), 0 18px 48px rgba(28, 71, 127, 0.13);
}

.search-icon {
  display: grid;
  width: 24px;
  height: 24px;
  margin-right: 14px;
  color: #71849c;
  place-items: center;
}

.search-icon svg {
  width: 100%;
  height: 100%;
}

.search-box input {
  width: 100%;
  min-width: 0;
  padding: 13px 0;
  color: var(--text);
  font-size: 16px;
  font-weight: 560;
  line-height: 1.4;
  background: transparent;
  border: 0;
  outline: 0;
}

.search-box input::placeholder {
  color: #95a3b5;
  font-weight: 470;
}

.search-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-width: 108px;
  min-height: 54px;
  padding: 0 20px;
  color: #fff;
  font-size: 14px;
  font-weight: 760;
  cursor: pointer;
  background: linear-gradient(135deg, #277bec, #1262d1);
  border: 0;
  border-radius: 13px;
  box-shadow: 0 8px 18px rgba(23, 105, 224, 0.22);
  transition: transform 150ms ease, box-shadow 150ms ease, opacity 150ms ease;
}

.search-button:hover:not(:disabled) {
  box-shadow: 0 10px 22px rgba(23, 105, 224, 0.3);
  transform: translateY(-1px);
}

.search-button:disabled {
  cursor: wait;
  opacity: 0.76;
}

.search-button svg {
  width: 18px;
  height: 18px;
}

.button-spinner {
  width: 15px;
  height: 15px;
  border: 2px solid rgba(255, 255, 255, 0.42);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 800ms linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.search-notice {
  margin: 12px 4px 0;
  color: #267f6f;
  font-size: 12px;
  font-weight: 600;
  text-align: left;
}

.search-notice.is-error {
  color: #c24848;
}

.search-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: min(820px, 100%);
  margin-top: 14px;
}

.advanced-toggle {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 10px;
  color: #516780;
  font-size: 12px;
  font-weight: 690;
  cursor: pointer;
  background: transparent;
  border: 0;
  border-radius: 8px;
  transition: color 150ms ease, background 150ms ease;
}

.advanced-toggle:hover,
.advanced-toggle.is-open {
  color: var(--blue);
  background: rgba(230, 240, 254, 0.72);
}

.toggle-icon,
.toggle-chevron {
  width: 17px;
  height: 17px;
}

.toggle-chevron {
  width: 14px;
  height: 14px;
  transition: transform 160ms ease;
}

.advanced-toggle.is-open .toggle-chevron {
  transform: rotate(180deg);
}

.filter-count {
  display: grid;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  color: #fff;
  font-size: 10px;
  background: var(--blue);
  border-radius: 999px;
  place-items: center;
}

.default-search-copy {
  color: #8190a3;
  font-size: 11px;
  font-weight: 570;
}

.advanced-panel {
  width: min(820px, 100%);
  margin-top: 14px;
  padding: 25px;
  text-align: left;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #d6e1ef;
  border-radius: 17px;
  box-shadow: 0 16px 42px rgba(33, 70, 117, 0.08);
  animation: reveal 180ms ease-out;
}

@keyframes reveal {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.advanced-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e6ecf4;
}

.advanced-heading h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 760;
}

.advanced-heading p {
  margin: 6px 0 0;
  color: var(--muted);
  font-size: 11px;
  line-height: 1.55;
}

.reset-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  padding: 7px 9px;
  color: #65768c;
  font-size: 11px;
  font-weight: 650;
  cursor: pointer;
  background: #f7f9fc;
  border: 1px solid #dce5ef;
  border-radius: 8px;
}

.reset-button svg {
  width: 14px;
  height: 14px;
}

.advanced-group {
  margin-top: 20px;
}

.group-label,
.filter-label {
  display: block;
  margin-bottom: 8px;
  color: #52667f;
  font-size: 10px;
  font-weight: 720;
}

.mode-options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
}

.mode-option {
  position: relative;
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
  min-height: 62px;
  padding: 11px 12px;
  text-align: left;
  cursor: pointer;
  background: #f8fafc;
  border: 1px solid #dce5ef;
  border-radius: 11px;
  transition: border-color 150ms ease, background 150ms ease;
}

.mode-option.is-active {
  background: #f1f7ff;
  border-color: #72a9f2;
  box-shadow: inset 0 0 0 1px rgba(23, 105, 224, 0.08);
}

.mode-radio {
  display: block;
  flex: 0 0 auto;
  width: 14px;
  height: 14px;
  background: #fff;
  border: 1.5px solid #afc0d4;
  border-radius: 50%;
}

.mode-option.is-active .mode-radio {
  border: 4px solid var(--blue);
}

.mode-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.mode-copy strong {
  color: #2b405c;
  font-size: 12px;
  font-weight: 720;
}

.mode-copy small {
  overflow: hidden;
  color: #8291a4;
  font-size: 9px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.recommended-badge {
  position: absolute;
  top: 7px;
  right: 7px;
  padding: 2px 5px;
  color: #157469;
  font-size: 7px;
  font-weight: 800;
  background: #ddf6f2;
  border-radius: 4px;
}

.advanced-grid {
  display: grid;
  grid-template-columns: 0.8fr 1.3fr 1fr;
  gap: 15px 12px;
  margin-top: 22px;
}

.filter-field {
  min-width: 0;
}

.filter-journal {
  grid-column: span 2;
}

.filter-field input,
.filter-field select {
  width: 100%;
  height: 40px;
  padding: 0 11px;
  color: #354963;
  font-size: 11px;
  font-weight: 560;
  background: #f8fafc;
  border: 1px solid #d8e2ee;
  border-radius: 9px;
  outline: 0;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.filter-field input:focus,
.filter-field select:focus {
  border-color: #75aaf0;
  box-shadow: 0 0 0 3px rgba(45, 124, 242, 0.08);
}

.select-wrap {
  position: relative;
}

.select-wrap select {
  padding-right: 31px;
  cursor: pointer;
  appearance: none;
}

.select-wrap svg {
  position: absolute;
  top: 50%;
  right: 10px;
  width: 14px;
  height: 14px;
  color: #8796a9;
  pointer-events: none;
  transform: translateY(-50%);
}

.year-range {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 6px;
  color: #93a0b1;
}

.quick-searches {
  width: min(820px, 100%);
  margin-top: 30px;
}

.quick-label {
  display: block;
  margin-bottom: 10px;
  color: #8190a3;
  font-size: 10px;
  font-weight: 720;
}

.quick-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}

.quick-list button {
  max-width: 100%;
  padding: 8px 12px;
  overflow: hidden;
  color: #667990;
  font-size: 10px;
  font-weight: 560;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid #dce5ef;
  border-radius: 999px;
  transition: color 150ms ease, border-color 150ms ease, background 150ms ease;
}

.quick-list button:hover {
  color: var(--blue);
  background: #fff;
  border-color: #a8c8f3;
}

.quick-list button span {
  margin-right: 5px;
  color: #198d7e;
  font-weight: 760;
}

.results-section {
  margin-bottom: 52px;
  padding: 31px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #d8e3ef;
  border-radius: 22px;
  box-shadow: 0 17px 48px rgba(39, 68, 106, 0.07);
}

.results-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 23px;
  border-bottom: 1px solid #e5ebf3;
}

.results-title {
  min-width: 0;
  flex: 1 1 auto;
}

.results-eyebrow {
  display: block;
  margin-bottom: 7px;
  color: var(--blue);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.13em;
}

.results-title h2 {
  margin: 0;
  overflow: hidden;
  color: var(--navy);
  font-size: 21px;
  font-weight: 760;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.results-title p {
  margin: 7px 0 0;
  color: #7c8ba0;
  font-size: 11px;
}

.model-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px 7px;
  margin-top: 10px;
}

.model-line span {
  color: #71839a;
  font-size: 8px;
  font-weight: 760;
  letter-spacing: 0.03em;
}

.model-line strong {
  color: #167e70;
  font-size: 9px;
  font-weight: 650;
}

.model-line i {
  width: 1px;
  height: 10px;
  background: #d8e2ed;
}

.results-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(76px, 1fr));
  flex: 0 0 auto;
  min-width: 408px;
  overflow: hidden;
  background: #f6f9fd;
  border: 1px solid #e0e8f2;
  border-radius: 12px;
}

.summary-item {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
  padding: 11px 13px;
}

.summary-item + .summary-item {
  border-left: 1px solid #dae3ee;
}

.summary-item span {
  overflow: hidden;
  color: #8492a5;
  font-size: 8px;
  font-weight: 680;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.summary-item strong {
  color: var(--navy);
  font-size: 16px;
  font-weight: 760;
}

.summary-item small {
  margin-left: 2px;
  color: #72839a;
  font-size: 8px;
  font-weight: 620;
}

.result-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
}

.result-card {
  position: relative;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 16px;
  padding: 22px 22px 19px;
  background: #fff;
  border: 1px solid #e0e7f0;
  border-radius: 15px;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.result-card:hover {
  border-color: #c3d4e8;
  box-shadow: 0 9px 24px rgba(30, 68, 116, 0.06);
  transform: translateY(-1px);
}

.result-card.is-expanded {
  border-color: #aac9f2;
}

.rank-badge {
  display: grid;
  flex: 0 0 auto;
  width: 31px;
  height: 31px;
  color: var(--blue);
  font-size: 12px;
  font-weight: 800;
  background: #edf5ff;
  border: 1px solid #d0e3fb;
  border-radius: 9px;
  place-items: center;
}

.result-main {
  min-width: 0;
}

.result-badges {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 9px;
}

.result-badges span {
  padding: 3px 6px;
  color: #74849a;
  font-size: 8px;
  font-weight: 680;
  background: #f4f7fa;
  border-radius: 5px;
}

.result-badges .type-badge {
  color: #1466cc;
  background: #eaf3ff;
}

.result-badges .caption-badge {
  color: #137d70;
  background: #e7f7f4;
}

.result-badges .evidence-badge {
  color: #7a5a13;
  background: #fff5d8;
}

.result-main h3 {
  margin: 0;
  color: #1d3451;
  font-size: 16px;
  font-weight: 720;
  line-height: 1.45;
}

.result-source {
  margin: 7px 0 0;
  color: #75869b;
  font-size: 10px;
  font-weight: 560;
}

.chunk-meta {
  display: grid;
  grid-template-columns: minmax(180px, 1.4fr) minmax(90px, 0.7fr) minmax(118px, 0.8fr) minmax(92px, 0.65fr);
  gap: 1px;
  margin-top: 13px;
  overflow: hidden;
  background: #dfe8f2;
  border: 1px solid #dfe8f2;
  border-radius: 9px;
}

.chunk-meta-item {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
  padding: 9px 11px;
  background: #f8fbff;
}

.chunk-meta-item span {
  color: #8292a6;
  font-size: 8px;
  font-weight: 680;
}

.chunk-meta-item strong {
  overflow: hidden;
  color: #405a77;
  font-size: 10px;
  font-weight: 650;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.chunk-meta-item.is-score strong {
  color: #1769d8;
  font-variant-numeric: tabular-nums;
}

.evidence-preview {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  margin-top: 13px;
  padding: 11px 12px;
  background: #f8fafc;
  border: 1px solid #e8edf3;
  border-radius: 9px;
}

.evidence-preview > span {
  padding-top: 2px;
  color: #247061;
  font-size: 8px;
  font-weight: 740;
}

.result-excerpt {
  display: -webkit-box;
  margin: 0;
  overflow: hidden;
  color: #52677f;
  font-size: 12px;
  line-height: 1.7;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.result-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 17px;
  padding-top: 13px;
  border-top: 1px solid #edf1f5;
}

.score-wrap {
  display: flex;
  align-items: baseline;
  gap: 7px;
}

.score-wrap span {
  color: #8493a6;
  font-size: 9px;
  font-weight: 650;
}

.score-wrap strong {
  color: #1769d8;
  font-size: 13px;
  font-weight: 760;
}

.detail-button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 2px;
  color: #62778f;
  font-size: 10px;
  font-weight: 680;
  cursor: pointer;
  background: transparent;
  border: 0;
}

.detail-button svg {
  width: 13px;
  height: 13px;
  transition: transform 150ms ease;
}

.result-card.is-expanded .detail-button svg {
  transform: rotate(180deg);
}

.result-detail {
  grid-column: 2;
  padding: 16px;
  background: #f7f9fc;
  border: 1px solid #e5ebf2;
  border-radius: 11px;
  animation: reveal 160ms ease-out;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
}

.context-block {
  margin-top: 15px;
  padding-top: 14px;
  border-top: 1px solid #e1e8f0;
}

.context-heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 9px;
}

.context-heading h4 {
  margin: 0;
  color: #425872;
  font-size: 10px;
  font-weight: 710;
}

.context-heading span {
  color: #8997a9;
  font-size: 8px;
}

.context-sequence {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.context-item {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 10px;
  padding: 9px 10px;
  background: #fff;
  border: 1px solid #e3e9f1;
  border-radius: 8px;
}

.context-item.is-current {
  background: #eef7ff;
  border-color: #c7dcf5;
}

.context-item span {
  color: #8997a9;
  font-size: 8px;
  font-weight: 680;
}

.context-item.is-current span {
  color: #1769d8;
}

.context-item p {
  margin: 0;
  color: #586d84;
  font-size: 9px;
  line-height: 1.55;
}

.detail-grid div {
  min-width: 0;
}

.detail-grid dt {
  margin-bottom: 4px;
  color: #8a98aa;
  font-size: 8px;
  font-weight: 650;
}

.detail-grid dd {
  margin: 0;
  overflow: hidden;
  color: #425872;
  font-size: 10px;
  font-weight: 630;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.keyword-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 14px;
  padding-top: 13px;
  border-top: 1px solid #e1e8f0;
}

.keyword-row > span {
  flex: 0 0 auto;
  padding-top: 3px;
  color: #8997a9;
  font-size: 8px;
  font-weight: 650;
}

.keyword-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.keyword-list em {
  padding: 3px 7px;
  color: #526b86;
  font-size: 9px;
  font-style: normal;
  font-weight: 570;
  background: #fff;
  border: 1px solid #dce5ef;
  border-radius: 999px;
}

.empty-state {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 62px 20px 48px;
  text-align: center;
}

.empty-icon {
  display: grid;
  width: 50px;
  height: 50px;
  margin-bottom: 15px;
  color: #8799af;
  background: #f2f6fa;
  border-radius: 15px;
  place-items: center;
}

.empty-icon svg {
  width: 29px;
  height: 29px;
}

.empty-state h3 {
  margin: 0;
  font-size: 16px;
}

.empty-state p {
  margin: 8px 0 18px;
  color: #7a8a9e;
  font-size: 11px;
}

.empty-state button {
  padding: 8px 12px;
  color: var(--blue);
  font-size: 10px;
  font-weight: 680;
  cursor: pointer;
  background: #eff6ff;
  border: 1px solid #cce0fb;
  border-radius: 8px;
}

.page-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 0 34px;
  color: #8997a9;
  font-size: 9px;
}

button:focus-visible,
input:focus-visible,
select:focus-visible {
  outline: 3px solid rgba(45, 124, 242, 0.2);
  outline-offset: 2px;
}

.hero.is-compact {
  padding: 42px 0 30px;
}

.hero.is-compact .hero-label,
.hero.is-compact h1,
.hero.is-compact > p,
.hero.is-compact .quick-searches {
  display: none;
}

.hero.is-compact .search-form {
  margin-top: 0;
}

@media (max-width: 860px) {
  .hero {
    padding-top: 70px;
  }
  .advanced-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .filter-journal {
    grid-column: auto;
  }
  .results-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .results-summary {
    width: 100%;
    min-width: 0;
  }
  .detail-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .header-inner,
  .main-content {
    width: min(100% - 28px, 1040px);
  }
  .site-header {
    height: 60px;
  }
  .header-status {
    display: none;
  }
  .database-button {
    min-width: 34px;
    padding: 0 8px;
  }
  .database-button span {
    display: none;
  }
  .database-drawer {
    width: min(100% - 14px, 500px);
  }
  .drawer-header,
  .drawer-content {
    padding-right: 18px;
    padding-left: 18px;
  }
  .hero {
    padding: 58px 0 44px;
  }
  .hero h1 {
    font-size: 34px;
  }
  .hero > p {
    font-size: 14px;
  }
  .hero > p br {
    display: none;
  }
  .search-box {
    min-height: 62px;
    padding-left: 15px;
    border-radius: 15px;
  }
  .search-icon {
    margin-right: 8px;
  }
  .search-box input {
    font-size: 14px;
  }
  .search-button {
    min-width: 76px;
    min-height: 48px;
    padding: 0 13px;
  }
  .search-button svg {
    display: none;
  }
  .default-search-copy {
    display: none;
  }
  .advanced-panel {
    padding: 20px 16px;
  }
  .advanced-heading p {
    display: none;
  }
  .mode-options,
  .advanced-grid {
    grid-template-columns: 1fr;
  }
  .mode-option {
    min-height: 56px;
  }
  .quick-list {
    justify-content: flex-start;
    flex-wrap: nowrap;
    margin-right: -14px;
    padding-right: 14px;
    overflow-x: auto;
  }
  .quick-list button {
    flex: 0 0 auto;
    max-width: 82vw;
  }
  .results-section {
    margin: 0 -2px 40px;
    padding: 21px 15px;
    border-radius: 18px;
  }
  .results-title {
    min-width: 0;
    max-width: 100%;
  }
  .results-title h2 {
    font-size: 18px;
  }
  .model-line i {
    display: none;
  }
  .results-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .summary-item:nth-child(3) {
    border-left: 0;
  }
  .summary-item:nth-child(n+3) {
    border-top: 1px solid #dae3ee;
  }
  .result-card {
    grid-template-columns: auto minmax(0, 1fr);
    gap: 11px;
    padding: 17px 13px;
  }
  .rank-badge {
    width: 27px;
    height: 27px;
  }
  .result-main h3 {
    font-size: 14px;
  }
  .result-excerpt {
    font-size: 11px;
  }
  .chunk-meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .evidence-preview {
    grid-template-columns: 1fr;
    gap: 5px;
  }
  .result-detail {
    grid-column: 1/-1;
  }
  .detail-grid {
    grid-template-columns: 1fr 1fr;
  }
  .context-item {
    grid-template-columns: 1fr;
    gap: 5px;
  }
}`],
})
export class PageMainComponent implements OnInit {
    public readonly config = SEARCH_CONFIG;
    public readonly searchModes = [
        {
            id: 'hybrid' as SearchMode,
            label: '통합 검색',
            caption: '키워드와 문맥을 함께 반영'
        },
        {
            id: 'dense' as SearchMode,
            label: '의미 검색',
            caption: '문장의 의미가 가까운 연구'
        },
        {
            id: 'keyword' as SearchMode,
            label: '키워드 검색',
            caption: '입력한 용어가 포함된 연구'
        }
    ];
    public readonly languages = ['전체', '한국어', '영어', '일본어'];
    public readonly fields = ['전체', '의생명', '에너지', '환경', '농림수산', '기계'];
    public readonly topKOptions = [3, 5, 10];
    public readonly chunkTypes: { id: MockChunkType; label: string }[] = [
        { id: 'body', label: '본문' },
        { id: 'abstract', label: '초록' },
        { id: 'table_caption', label: '표 캡션' },
        { id: 'figure_caption', label: '그림 캡션' },
        { id: 'supplemental_caption', label: '부록 캡션' }
    ];

    public query = '';
    public lastSearchedQuery = '';
    public searchMode: SearchMode = 'hybrid';
    public filters = this.createDefaultFilters();
    public results: SearchResultView[] = [];
    public totalMatches = 0;
    public timings: SearchTimings = this.emptyTimings();
    public notice = '';
    public noticeType: NoticeType = 'idle';
    public isSearching = false;
    public hasSearched = false;
    public isAdvancedSearchOpen = false;
    public isDatabasePanelOpen = false;
    public expandedResultIds = new Set<string>();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async onQueryInput(event: Event) {
        const input = event.target as HTMLInputElement;
        this.query = input.value;
        this.notice = '';
        this.noticeType = 'idle';
        await this.service.render();
    }

    public async toggleAdvancedSearch() {
        this.isAdvancedSearchOpen = !this.isAdvancedSearchOpen;
        await this.service.render();
    }

    public async openDatabasePanel() {
        this.isDatabasePanelOpen = true;
        await this.service.render();
    }

    public async closeDatabasePanel() {
        this.isDatabasePanelOpen = false;
        await this.service.render();
    }

    public async returnToHome() {
        this.query = '';
        this.lastSearchedQuery = '';
        this.results = [];
        this.totalMatches = 0;
        this.timings = this.emptyTimings();
        this.notice = '';
        this.noticeType = 'idle';
        this.isSearching = false;
        this.hasSearched = false;
        this.isAdvancedSearchOpen = false;
        this.isDatabasePanelOpen = false;
        this.expandedResultIds.clear();
        await this.service.render();
    }

    public async selectExample(query: string) {
        this.query = query;
        await this.submitSearch();
    }

    public async selectMode(mode: SearchMode) {
        this.searchMode = mode;
        if (this.hasSearched) {
            this.refreshResults();
        }
        await this.service.render();
    }

    public async onSelectFilter(event: Event, key: SelectFilterKey) {
        const select = event.target as HTMLSelectElement;
        this.filters[key] = select.value;
        await this.service.render();
    }

    public async onJournalInput(event: Event) {
        const input = event.target as HTMLInputElement;
        this.filters.journal = input.value;
        await this.service.render();
    }

    public async onYearInput(event: Event, key: 'yearFrom' | 'yearTo') {
        const input = event.target as HTMLInputElement;
        const parsed = Number(input.value);
        this.filters[key] = Number.isFinite(parsed) ? parsed : 0;
        await this.service.render();
    }

    public async onTopKChange(event: Event) {
        const select = event.target as HTMLSelectElement;
        this.filters.topK = Number(select.value);
        await this.service.render();
    }

    public async resetFilters() {
        this.filters = this.createDefaultFilters();
        this.searchMode = 'hybrid';
        if (this.hasSearched) {
            this.refreshResults();
            this.notice = this.results.length > 0
                ? '기본 조건으로 결과를 다시 정리했습니다.'
                : '검색 문장을 바꿔 다시 시도해 주세요.';
            this.noticeType = this.results.length > 0 ? 'ready' : 'error';
        }
        await this.service.render();
    }

    public async submitSearch(event?: Event) {
        event?.preventDefault();
        const normalizedQuery = this.query.trim();

        if (!normalizedQuery) {
            this.notice = '찾고 싶은 연구 주제나 질문을 입력해 주세요.';
            this.noticeType = 'error';
            await this.service.render();
            return;
        }

        if (this.filters.yearFrom && this.filters.yearTo
            && this.filters.yearFrom > this.filters.yearTo) {
            this.notice = '발행연도 시작 값을 종료 값보다 작게 입력해 주세요.';
            this.noticeType = 'error';
            this.isAdvancedSearchOpen = true;
            await this.service.render();
            return;
        }

        this.query = normalizedQuery;
        this.isSearching = true;
        this.notice = '';
        this.noticeType = 'idle';
        await this.service.render();

        await new Promise((resolve) => setTimeout(resolve, 320));
        this.refreshResults();
        this.lastSearchedQuery = normalizedQuery;
        this.hasSearched = true;
        this.isSearching = false;
        this.isAdvancedSearchOpen = false;
        this.expandedResultIds.clear();
        this.notice = this.results.length > 0
            ? ''
            : '근거가 충분한 결과가 없어 추측성 결과를 표시하지 않았습니다. 검색 문장을 구체화해 주세요.';
        this.noticeType = this.results.length > 0 ? 'idle' : 'error';
        await this.service.render();
    }

    public async toggleResult(resultId: string) {
        if (this.expandedResultIds.has(resultId)) {
            this.expandedResultIds.delete(resultId);
        } else {
            this.expandedResultIds.add(resultId);
        }
        await this.service.render();
    }

    public isExpanded(resultId: string) {
        return this.expandedResultIds.has(resultId);
    }

    public getSearchModeLabel() {
        return this.searchModes.find((mode) => mode.id === this.searchMode)?.label || '통합 검색';
    }

    public getChunkTypeLabel(chunkType: MockChunkType) {
        return this.chunkTypes.find((item) => item.id === chunkType)?.label || chunkType;
    }

    public formatScorePercent(value: number) {
        return (value * 100).toFixed(1);
    }

    public getPublicationIdentifier(result: SearchResultView) {
        if (result.doi) return `DOI ${result.doi}`;
        if (result.issn) return `ISSN ${result.issn}`;
        return '별도 식별자 미등록';
    }

    public getActiveFilterCount() {
        let count = 0;
        if (this.searchMode !== 'hybrid') count += 1;
        if (this.filters.language !== '전체') count += 1;
        if (this.filters.yearFrom !== 1900 || this.filters.yearTo !== 2026) count += 1;
        if (this.filters.field !== '전체') count += 1;
        if (this.filters.journal.trim()) count += 1;
        if (this.filters.topK !== 5) count += 1;
        return count;
    }

    public trackResult(_index: number, result: SearchResultView) {
        return result.id;
    }

    private createDefaultFilters() {
        return {
            language: '전체',
            yearFrom: 1900,
            yearTo: 2026,
            journal: '',
            field: '전체',
            topK: 5
        };
    }

    private emptyTimings(): SearchTimings {
        return {
            keyword_ms: 0,
            bi_encoder_ms: 0,
            cross_encoder_ms: 0,
            total_ms: 0
        };
    }

    private normalizeText(value: string) {
        return value
            .toLocaleLowerCase()
            .replace(/[^0-9a-zA-Z가-힣ぁ-んァ-ン一-龥]+/g, ' ')
            .trim();
    }

    private refreshResults() {
        const queryTerms = this.normalizeText(this.query)
            .split(/\s+/)
            .filter((term) => term.length > 1);
        const journalQuery = this.normalizeText(this.filters.journal);
        const candidates: SearchResultView[] = [];

        for (const item of MOCK_SEARCH_RESPONSE.results) {
            if (this.filters.language !== '전체' && item.language !== this.filters.language) continue;
            if (this.filters.yearFrom && item.year < this.filters.yearFrom) continue;
            if (this.filters.yearTo && item.year > this.filters.yearTo) continue;
            if (journalQuery && !this.normalizeText(item.journal).includes(journalQuery)) continue;
            if (this.filters.field !== '전체' && item.field !== this.filters.field) continue;

            const searchText = this.normalizeText([
                item.title,
                item.document_id,
                item.authors.join(' '),
                item.journal,
                item.field,
                item.section,
                item.keywords.join(' '),
                item.content.current
            ].join(' '));
            const matchCount = queryTerms.filter((term) => searchText.includes(term)).length;

            if (queryTerms.length === 0 || matchCount === 0) continue;

            const modeScore = this.searchMode === 'keyword'
                ? item.keyword_score
                : this.searchMode === 'dense'
                    ? item.similarity_score
                    : item.search_score;
            const queryBoost = Math.min(matchCount * 0.012, 0.05);

            candidates.push({
                ...item,
                rank: 0,
                displayScore: Math.min(modeScore + queryBoost, 0.9999),
                matchCount
            });
        }

        candidates.sort((a, b) => {
            if (b.matchCount !== a.matchCount) return b.matchCount - a.matchCount;
            if (b.displayScore !== a.displayScore) return b.displayScore - a.displayScore;
            return b.similarity_score - a.similarity_score;
        });

        this.totalMatches = candidates.length;
        this.results = candidates
            .slice(0, this.filters.topK)
            .map((item, index) => ({ ...item, rank: index + 1 }));

        const baseTimings = MOCK_SEARCH_RESPONSE.timings[this.searchMode];
        const filterCost = Math.max(candidates.length, 1) * 0.28;
        this.timings = {
            keyword_ms: baseTimings.keyword_ms,
            bi_encoder_ms: baseTimings.bi_encoder_ms,
            cross_encoder_ms: baseTimings.cross_encoder_ms,
            total_ms: Number((baseTimings.total_ms + filterCost).toFixed(1))
        };
    }
}

export default PageMainComponent;